export default __webpack_public_path__ + "static/earth-cae3f87820d766eb18b26298e3da5c81.webp";